<div class="modal fade show"  [ngClass]="{'expanded': isExpanded}" tabindex="-1" aria-labelledby="business-partners-modalLabel"
  aria-hidden="true" [ngStyle]="{'display': 'block'}">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <div class="d-flex w-100">
          <div class="me-2 id flex-fill">
            <h4 class="modal-title mb-0 item-id">Direct Reports
              <!-- <span class="ms-4" *ngFor="let rb of appList">
                <ejs-radiobutton [label]="rb.app" (change)="onRadioChange($event)" [checked]="rb.checked" name="default"></ejs-radiobutton>
              </span> -->
            </h4>
          </div>
          <div class="btns-header">
            <button class="expand-modal close" (click)="close()" aria-label="Close">
              <i class="fas fa-times" title="Close Popup"></i>
            </button>
            <button class="expand-modal close" (click)="expandCollapse()">
              <i class="fas ms-2 me-2" [ngClass]="{'fa-expand-alt': !isExpanded, 'fa-compress-alt': isExpanded}"
                [title]="isExpanded ? 'Exit Full Screen' : 'Enter Full Screen'"></i>
            </button>
          </div>
        </div>
      </div>




      <div class="modal-body p-0"
          [ngStyle]="{'display': 'block', 'overflow':'hidden', 'min-height':'fit-content'}">
        <app-loader *ngIf="!showGrid"></app-loader>
        <ejs-grid #popupGrid id="popupGrid" [dataSource]="popupData" [rowHeight]="'30'"
          [height]="gridHeight" [gridLines]="false" [allowFiltering]="true" [allowPaging]="true"
          [pageSettings]="pageSettings" [allowSorting]="true" [enableHover]="false" [allowResizing]="true" [searchSettings]="searchSettings"
          [allowReordering]="true" [showColumnChooser]="true" [allowExcelExport]="true" [allowSelection]="true"
          [editSettings]="{ allowEditing: false }" [enablePersistence]="false" [filterSettings]="{ type: 'Menu' }"
          [selectionSettings]="{ mode: 'Both', checkboxOnly: true }" [query]="query" (actionBegin)="onGridActionBegin($event)"
          (actionComplete)="onActionComplete($event, popupGrid)" (toolbarClick)="onToolbarClick($event)">
          <e-columns>
            <e-column *ngFor="let column of gridColumns;" [field]="column.field"
              [headerText]="column.headerText"
              [clipMode]="column.field === 'Actions' ? '' : 'EllipsisWithTooltip'" [type]="column.type"
              [width]="column.width" [filter]="column.filter ? column.filter : { type: 'Menu' }"
              [format]="column.format ? column.format : null" [textAlign]="column.textAlign"
              [showInColumnChooser]="column.showInColumnChooser ?? false" [visible]="column.visible"
              [commands]="column?.commands ? column.commands : null" [edit]="column.edit"
              [allowReordering]="column.allowReordering ?? false" [freeze]="column.freeze ? column.freeze: null"
              [allowEditing]="column.allowEditing" [allowSorting]="column.allowSorting"
              [allowFiltering]="!!column.allowFiltering">



            </e-column>
          </e-columns>
        </ejs-grid>
      </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-danger close-modal px-2" (click)="close()">Close</button>
          </div>

    </div>
  </div>

</div>



<ng-template #columnChooserForGrid>
  <app-column-chooser [grid]="AddressesPopupGrid"></app-column-chooser>
</ng-template>
